import { render } from "./CustomerMenu.vue?vue&type=template&id=753bb247&scoped=true"
import script from "./CustomerMenu.vue?vue&type=script&lang=js"
export * from "./CustomerMenu.vue?vue&type=script&lang=js"

import "./CustomerMenu.vue?vue&type=style&index=0&id=753bb247&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-753bb247"]])

export default __exports__